import {filterAndSortImageIds, filterAndSortImages} from '../utils';
import {createSelector} from 'reselect';
import {getSearchTerm, getSortBy} from './myImagesSettings';
import {getSelectedImageIds} from './selectedImages';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import {getUserId} from './openImage';

export const getImages = state => state.images;

export const getUserImages = createSelector(
    [getUserId, getImages],
    (userId, images) => {
        return userId && !isEmpty(images) ? images[userId] : {};
    }
);

export const getSuccessfulImages = createSelector(
    [getUserImages],
    (images) => {
        return pickBy(images, img => !img.error);
    }
);

export const getFilteredAndSortedImages = createSelector(
    [getSuccessfulImages, getSearchTerm, getSortBy],
    (images, searchTerm, sortBy) => {
        return filterAndSortImages(images, searchTerm, sortBy);
    }
);

export const getSortedSelectedImages = createSelector(
    [getSuccessfulImages, getSearchTerm, getSortBy, getSelectedImageIds],
    (images, searchTerm, sortBy, selectedImageIds) => {
        return filterAndSortImageIds(selectedImageIds, images, searchTerm, sortBy);
    }
);



// WEBPACK FOOTER //
// ./src/reducers/imagesSelector.js